import styled from 'styled-components';

export const StyledDot = styled.span`
  display: inline-block;
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background-color: ${props => props.color};
`;

